import React, { Component } from 'react'
import { connect } from 'react-redux'

import './productionstatusoverview.scss'

// Utils
import { hasSubscriptionPermission } from '../../../utils/auth'

// Actions
import { getProductionStatus } from '../../../actions/overview'

// Components
import Overview from '../Overview'

class ProductionStatusOverview extends Component {
  constructor (props) {
    super(props)

    this.pageRef = null

    this.state = {
    }
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 30)) return null

    return (
      <Overview
        itemType='order'
        getItems={this.props.getProductionStatus}
      />
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getProductionStatus
})(ProductionStatusOverview)



// WEBPACK FOOTER //
// ./src/app/shared/components/ProductionStatusOverview/index.js